import strings from 'strings'

// Maps the application's current status (from ApplicationStatus.status) to a dot color.
export const STATUS_COLORS = {
    'New': '#3B82F6',
    'Under Review': 'var(--status-pending)',
    'Pending': '#7B61FF',
    'Approved': 'var(--status-approved)',
    'Declined': 'var(--status-declined)',
    'Cancelled': 'var(--fg-tertiary)'
}

// Avatar palette cycled through team members.
export const AVATAR_PALETTE = [
    { bg: '#E0E7FF', color: '#4338CA' },
    { bg: '#7B61FF', color: '#fff' },
    { bg: '#D1FAE5', color: '#065F46' },
    { bg: 'var(--badge-declined-bg)', color: 'var(--badge-declined-ink)' },
    { bg: 'var(--badge-watch-bg)', color: 'var(--badge-watch-ink)' }
]

export const getInitials = (first, last) => {
    const f = (first || '').charAt(0).toUpperCase()
    const l = (last || '').charAt(0).toUpperCase()
    return (f + l) || '?'
}

export const formatHrs = (hrs) => (hrs == null ? '—' : (Math.round(hrs * 10) / 10).toFixed(1))

export const agendaTagStyle = (style) => {
    switch (style) {
        case 'URGENT': return { backgroundColor: 'var(--badge-declined-bg)', color: 'var(--badge-declined-ink)' }
        case 'INFO': return { backgroundColor: '#EDE9FE', color: '#5B21B6' }
        case 'SUCCESS': return { backgroundColor: '#D1FAE5', color: '#065F46' }
        case 'DARK': return { backgroundColor: 'var(--badge-watch-bg)', color: 'var(--badge-watch-ink)' }
        default: return { backgroundColor: '#f0f2f5', color: 'var(--fg-tertiary)' }
    }
}

export const donutOptions = {
    chart: { type: 'radialBar', sparkline: { enabled: true } },
    plotOptions: {
        radialBar: {
            startAngle: -135, endAngle: 135,
            hollow: { size: '62%' },
            track: { background: '#EDE9FE', strokeWidth: '100%' },
            dataLabels: {
                name: { show: true, offsetY: 22, fontSize: '11px', color: 'var(--neutral-400)', fontWeight: 600 },
                value: { offsetY: -12, fontSize: '28px', fontWeight: 800, color: 'var(--neutral-900)', formatter: (val) => `${val}%` }
            }
        }
    },
    fill: { colors: ['#6f5bd8'] },
    labels: [strings.UD.WEEKLY_TARGET],
    stroke: { lineCap: 'round' }
}
